import { render } from "./simple.vue?vue&type=template&id=70b5f73a&scoped=true"
import script from "./simple.vue?vue&type=script&lang=js"
export * from "./simple.vue?vue&type=script&lang=js"

import "./simple.vue?vue&type=style&index=0&id=70b5f73a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b5f73a"]])

export default __exports__